import { Component, OnInit, ViewChild } from "@angular/core";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { ToastrService } from "ngx-toastr";
import { Globals } from "src/app/common/global";
import { ConfigApi } from "src/app/config-api";
import { ApiCallingService } from "src/app/services/api-calling.service";

@Component({
  selector: "app-manage-spot-refund",
  templateUrl: "./manage-spot-refund.component.html",
  styleUrls: ["./manage-spot-refund.component.css"],
})
export class ManageSpotRefundComponent implements OnInit {
  @ViewChild("refundModal") refundModal: any;
  totalcount: number = 0;
  page: number = 0;
  pageSize: number = 10;
  operator_id: string = "";
  SlotBookingList: any[] = [];
  refundData: any = "";
  detail: any = {
    is_refund_full_amount: null,
    amountTotal: null,
  };
  isLoading: boolean = false;

  constructor(
    private apiCallingService: ApiCallingService,
    private Globals: Globals,
    private modalService: NgbModal,
    private toastr: ToastrService
  ) {}

  ngOnInit(): void {
    this.operator_id = this.Globals.getUser()._id;
    this.getList();
  }

  getList(): void {
    let page = this.page == 0 ? 0 : this.page - 1;
    this.apiCallingService
      .callAPI(
        {},
        "GET",
        ConfigApi.URLS.SPOT_BOOKING.REFUND_LIST +
          "?operator_id=" +
          this.operator_id +
          "&page=" +
          page +
          "&limit=" +
          this.pageSize
      )
      .subscribe(
        (res) => {
          if (this.apiCallingService.handleSuccess(res)) {
            this.SlotBookingList = res.data;
            this.totalcount = res.total;
          } else {
            console.error(res.msg);
          }
        },
        (err) => {
          console.error("Error occurred while fetching data:", err);
        }
      );
  }

  resetRefund() {
    this.detail = { is_refund_full_amount: null, amountTotal: null };
  }

  openRefundModal(spotPurchase: any) {
    this.modalService.open(this.refundModal, {
      size: "md",
      backdrop: "static",
    });
    this.refundData = spotPurchase;
  }

  submitRefund(form: any) {
    if (this.detail.is_refund_full_amount === false) {
      if (!this.detail.amountTotal) {
        return;
      }
    }

    this.isLoading = true;

    const payload: any = {
      spotPurchaseSlotId: this.refundData?._id,
      is_refund_full_amount: this.detail.is_refund_full_amount,
    };

    if (this.detail.is_refund_full_amount === false) {
      payload.refund_amount = this.detail.amountTotal;
    }

    this.apiCallingService
      .callAPI(payload, "POST", ConfigApi.URLS.SPOT_BOOKING.REFUND_SPOT_BOOKING)
      .subscribe(
        (res) => {
          if (this.apiCallingService.handleSuccess(res)) {
            this.toastr.success(
              res.msg || "Refund processed successfully",
              "Success"
            );
            this.modalService.dismissAll();
            this.resetRefund();
            this.getList();
            this.isLoading = false;
          } else {
            this.toastr.error(res.msg, "Error");
            this.isLoading = false;
            this.resetRefund();
          }
        },
        (err) => {
          this.toastr.error(err.error.msg, "Error");
          this.isLoading = false;
          this.resetRefund();
        }
      );
  }
  getIsDisabled(): boolean {
    if (this.detail.is_refund_full_amount === null) {
      return true;
    }
    if (
      this.detail.is_refund_full_amount === false &&
      (this.detail.amountTotal === null || this.detail.amountTotal <= 0)
    ) {
      return true;
    }

    return false;
  }

  loadPage(page: number): void {
    if (page) {
      this.page = page;
      this.getList();
    }
  }
}
